__turbopack_context__.v({
  "desktopPrimaryOffers": "RareProductSelectionSection-module__IUxCUq__desktopPrimaryOffers",
  "leftPanel": "RareProductSelectionSection-module__IUxCUq__leftPanel",
  "mobilePrimaryOffers": "RareProductSelectionSection-module__IUxCUq__mobilePrimaryOffers",
  "primaryOffersSlot": "RareProductSelectionSection-module__IUxCUq__primaryOffersSlot",
  "rightPanel": "RareProductSelectionSection-module__IUxCUq__rightPanel",
  "section": "RareProductSelectionSection-module__IUxCUq__section",
  "stickyPanel": "RareProductSelectionSection-module__IUxCUq__stickyPanel",
  "wrapper": "RareProductSelectionSection-module__IUxCUq__wrapper",
});
